import { render, staticRenderFns } from "./MaterialEditor.vue?vue&type=template&id=6eef1594&scoped=true&"
import script from "./MaterialEditor.vue?vue&type=script&lang=js&"
export * from "./MaterialEditor.vue?vue&type=script&lang=js&"
import style0 from "./MaterialEditor.vue?vue&type=style&index=0&id=6eef1594&prod&scoped=true&lang=css&"
import style1 from "./MaterialEditor.vue?vue&type=style&index=1&id=6eef1594&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef1594",
  null
  
)

export default component.exports